import { AApi } from "@/service/AApi";

const API = new AApi(
  {
    url: "sx/khach-hangs",
  },
);

export default API;
